import { ReactNode } from 'react';
import dynamic from 'next/dynamic';

import spinner from '@public/img/partnerships/spinner.json';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

export const PageLoader = ({
  isLoading,
  children,
}: {
  isLoading: boolean;
  children: ReactNode;
}): JSX.Element => {
  if (isLoading) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <Lottie
          animationData={spinner}
          style={{
            maxWidth: 300,
            minWidth: 300,
          }}
          loop
        />
      </div>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
